<template>
  <div>
    <div class="relative">
      <div v-if="slots.icon" class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <slot name="icon" class="" />
      </div>
      <Input :id="id" ref="inputRef" :name="name" type="text" :disabled="disabled" :aria-label="label" @input="$emit('update:modelValue', ($event.target as HTMLInputElement)?.value)" />
    </div>
    <InputErrors :errors="error" />
  </div>
</template>

<script setup lang="ts">
  import { PropType, onMounted, useSlots } from 'vue';
  import { useCurrencyInput, CurrencyInputOptions } from 'vue-currency-input';
  import InputErrors from './InputErrors.vue';
  import { Input } from '@/components/ui/input';

  const slots = useSlots();

  const { options } = defineProps({
    modelValue: { type: [String, Number], default: 0 },
    id: { type: String, default: '' },
    name: { type: String, default: '' },
    password: { type: Boolean, default: false },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    autocomplete: { type: String, default: '' },
    error: { type: [String, Array], default: '' },
    min: { type: Number, default: null },
    max: { type: Number, default: null },
    disabled: { type: Boolean, default: false },
    options: { type: Object as PropType<CurrencyInputOptions>, required: true },
    readonly: { type: Boolean, default: false },
  });

  defineEmits(['update:modelValue', 'change']);

  const { inputRef } = useCurrencyInput(options);

  onMounted(() => {
    if (!inputRef.value) {
      return;
    }
    // format the initial value
    if (inputRef.value.$el.hasAttribute('autofocus')) {
      inputRef.value.focus();
    }
  });

  defineExpose({
    // expose focus, allowing the parent to trigger focus on the input
    focus: () => inputRef.value?.focus(),
  });
</script>
